/* tslint:disable */
/* eslint-disable */
/**
 * attachmentAV
 * An SDK to integrate virus and malware scan capabilities into JavaScript / TypeScript applications. Scan files for viruses, trojans, and other kinds of malware with attachmentAV powered by Sophos.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScanResult
 */
export interface ScanResult {
    /**
     * 
     * @type {string}
     * @memberof ScanResult
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof ScanResult
     */
    finding?: string;
    /**
     * 
     * @type {number}
     * @memberof ScanResult
     */
    size?: number;
    /**
     * 
     * @type {string}
     * @memberof ScanResult
     */
    realfiletype?: string;
}

/**
 * Check if a given object implements the ScanResult interface.
 */
export function instanceOfScanResult(value: object): value is ScanResult {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ScanResultFromJSON(json: any): ScanResult {
    return ScanResultFromJSONTyped(json, false);
}

export function ScanResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScanResult {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'finding': json['finding'] == null ? undefined : json['finding'],
        'size': json['size'] == null ? undefined : json['size'],
        'realfiletype': json['realfiletype'] == null ? undefined : json['realfiletype'],
    };
}

export function ScanResultToJSON(json: any): ScanResult {
    return ScanResultToJSONTyped(json, false);
}

export function ScanResultToJSONTyped(value?: ScanResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'finding': value['finding'],
        'size': value['size'],
        'realfiletype': value['realfiletype'],
    };
}

